import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { IRenewalEmailConfigTabProps } from '@/@types/insurance';

export function RenewalEmailConfigTab({
  emailConfig,
  onEmailConfigChange,
}: IRenewalEmailConfigTabProps) {
  const isGmail = emailConfig.provider === 'gmail';

  return (
    <div className="space-y-6 py-4">
      <div className="space-y-2">
        <Label htmlFor="email-provider">Email provider</Label>
        <Select
          value={emailConfig.provider}
          onValueChange={value =>
            onEmailConfigChange({
              ...emailConfig,
              provider: value as 'resend' | 'gmail',
            })
          }
        >
          <SelectTrigger id="email-provider" className="max-w-[220px]">
            <SelectValue placeholder="Select provider" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="resend">Resend (recommended)</SelectItem>
            <SelectItem value="gmail">Gmail (app password)</SelectItem>
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground">
          Resend uses a pre-configured API key. Gmail requires an app password.
        </p>
      </div>

      {isGmail && (
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="gmail-user">Gmail address</Label>
            <Input
              id="gmail-user"
              type="email"
              placeholder="you@gmail.com"
              value={emailConfig.gmailUser ?? ''}
              onChange={e =>
                onEmailConfigChange({ ...emailConfig, gmailUser: e.target.value })
              }
              className="max-w-[320px]"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="gmail-password">App password</Label>
            <Input
              id="gmail-password"
              type="password"
              placeholder="16-character app password"
              value={emailConfig.gmailAppPassword ?? ''}
              onChange={e =>
                onEmailConfigChange({ ...emailConfig, gmailAppPassword: e.target.value })
              }
              className="max-w-[320px]"
            />
            <p className="text-xs text-muted-foreground">
              Generate an app password in your Google account security settings.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
